const swagger = {
    invalid_zod_type: 'Tipo Zod inválido. Por favor, verifique la configuración del guardia de ruta.',
    not_supported_zod_type_for_params: 'Tipo Zod no soportado para los parámetros. Por favor, verifique la configuración del guardia de ruta.',
};
export default swagger;
